import React from 'react';
import AssetSettings from '../AssetSettings';

// Tillgångar section — automation switch + category/account defaults for the
// fixed-asset register. Ungated: the register itself is available to all
// tenants, so its settings are too.
const AssetsSection = ({ companyId }) => (
  <div id="tillgangar">
    <AssetSettings companyId={companyId} />
  </div>
);

export default AssetsSection;
